// extracted by mini-css-extract-plugin
module.exports = {"gwSelectBoxStyle":"SelectProducerCode_gwSelectBoxStyle__3lz7E"};